import React, { useMemo } from "react";
import { resolveLdsFinancialState } from "../../../utils/orders/resolveLdsFinancialState";
import { resolveMixedPaymentDisplayState } from "../../../utils/orders/resolveMixedPaymentDisplayState";
import MixedPaymentStatusDisplay from "../../Orders/MixedPaymentStatusDisplay";

export function formatLdsPaymentIls(amount) {
  if (amount == null || !Number.isFinite(Number(amount))) return "—";
  return `₪${Number(amount).toLocaleString("he-IL")}`;
}

/** @returns {null | { totalAmount: number|null, paidAmount: number, remainingBalance: number|null, isPartialPaid: boolean, isFullyPaid: boolean, isUnpaid: boolean }} */
export function useLdsPaymentFinancialSummary(orderReqData, enabled) {
  return useMemo(() => {
    if (!enabled || !orderReqData) return null;
    const fin = resolveLdsFinancialState(orderReqData);
    return {
      totalAmount: fin.totalAmount,
      paidAmount: fin.paidAmount,
      remainingBalance: fin.remainingBalance,
      isPartialPaid: fin.isPartialPaid,
      isFullyPaid: fin.isFullyPaid,
      isUnpaid: fin.isUnpaid,
    };
  }, [orderReqData, enabled]);
}

function SummaryRow({ label, value, emphasize = false, className = "" }) {
  return (
    <div
      className={`lds-payment-financial-row ${emphasize ? "lds-payment-financial-row--emphasis" : ""} ${className}`.trim()}
    >
      <span className="lds-payment-financial-label">{label}</span>
      <strong className="lds-payment-financial-value">{formatLdsPaymentIls(value)}</strong>
    </div>
  );
}

/**
 * LDS payment checkout — three distinct totals (order / paid / remaining).
 * SSOT: resolveLdsFinancialState(orderReqData).
 */
export default function LdsPaymentFinancialSummary({
  summary,
  orderReqData = null,
  variant = "default",
  className = "",
}) {
  const mixedDisplay = useMemo(
    () => (orderReqData ? resolveMixedPaymentDisplayState(orderReqData) : null),
    [orderReqData]
  );

  if (!summary) return null;

  const { totalAmount, paidAmount, remainingBalance } = summary;
  const rootClass = [
    "lds-payment-financial-summary",
    variant === "compact" ? "lds-payment-financial-summary--compact" : "",
    variant === "hero" ? "lds-payment-financial-summary--hero" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClass}>
      {mixedDisplay?.applies ? (
        <div className="lds-payment-financial-summary__status" dir="rtl">
          <MixedPaymentStatusDisplay
            displayStatus={mixedDisplay.displayStatus}
            badges={mixedDisplay.badges}
            variant="badges"
          />
        </div>
      ) : null}
      <SummaryRow label="סה״כ הזמנה:" value={totalAmount} />
      <SummaryRow label="שולם / נתפס:" value={paidAmount} />
      <SummaryRow
        label="יתרה לתשלום:"
        value={remainingBalance}
        emphasize
      />
    </div>
  );
}
